import { useAtomValue, useSetAtom } from 'jotai';
import React__default, { useRef, useState, useEffect, useCallback } from 'react';
import { useForm, Controller } from 'react-hook-form';
import '../../../rev/layouts/Alignment/alignment.scss';
import '../../../rev/layouts/Box.js';
import { Group } from '../../../rev/layouts/Group.js';
import '../../../rev/layouts/Section.js';
import '../../../rev/layouts/Spacing/spacing.scss';
import { Stack } from '../../../rev/layouts/Stack.js';
import '../../../rev/atoms/Badge.scss';
import 'react-aria-components';
import '../../../rev/atoms/Breadcrumbs.scss';
import { Button } from '../../../rev/atoms/Button.js';
import { Callout } from '../../../rev/atoms/Callout.js';
import '../../../rev/atoms/Card.scss';
import '../../../rev/atoms/Checkbox.js';
import 'lodash';
import '../../../rev/atoms/CheckboxGroup.scss';
import '../../../rev/atoms/Tag.scss';
import '../../../rev/atoms/Chip.scss';
import '../../../rev/atoms/DateInput.js';
import '../../../rev/atoms/Text.js';
import '../../../rev/atoms/Divider.scss';
import '../../../rev/atoms/Spinner.scss';
import '../../../rev/atoms/Dropzone.scss';
import '../../../rev/atoms/Empty.scss';
import 'motion/react';
import '../../../rev/molecules/RichDescription.js';
import '../../../rev/molecules/TitleGroup.scss';
import '../../../rev/atoms/EmptySearchResults.scss';
import 'classnames';
import '../../../rev/atoms/Image.scss';
import '@mui/icons-material/EmailOutlined';
import '@mui/icons-material/PhoneOutlined';
import '@mui/icons-material/PlaceOutlined';
import '@mui/icons-material/ScheduleOutlined';
import '../../../rev/atoms/LabelledList.scss';
import '../../../rev/atoms/LabelPrice.scss';
import '../../../rev/atoms/Link.scss';
import '../../../rev/atoms/ListViewGroup.scss';
import '../../../rev/atoms/ListViewRow.scss';
import '../../../rev/atoms/Note.scss';
import '../../../rev/atoms/OldTextInput.js';
import '../../../rev/atoms/RadioGroup.scss';
import 'framer-motion';
import '../../../rev/atoms/SegmentedControl.scss';
import '../../../rev/atoms/Skeleton.scss';
import '@mui/icons-material/InfoOutline';
import '../../../rev/molecules/Tooltip/Tooltip.js';
import '../../../rev/atoms/Slider.scss';
import '../../../rev/atoms/SteppedProgressBar.scss';
import '../../../rev/atoms/Switch.js';
import '../../../rev/atoms/Tabs.scss';
import '../../../rev/atoms/TextArea.js';
import '../../../rev/atoms/TextInput.js';
import '../../../rev/atoms/TimeInput.js';
import '../../../rev/atoms/ToggleButton.js';
import '../../../rev/atoms/ToggleGroup.js';
import 'react-dom';
import '../../../rev/molecules/EmbeddedVideoPlayer/EmbeddedVideoPlayer.scss';
import '../../../rev/molecules/Accordion.scss';
import '../../../rev/molecules/ActionMenu.scss';
import '../../../rev/molecules/BankInfo/BankInfo.scss';
import '../../../rev/molecules/Carousel.scss';
import '../../../rev/molecules/ContentSlider.js';
import '../../../rev/molecules/Drawer.js';
import '../../../rev/molecules/Dropdown.scss';
import '../../../rev/molecules/Form/index.js';
import '@dnd-kit/core';
import '../../../rev/molecules/Kanban/KanbanBoard.scss';
import '../../../rev/molecules/Lightbox.scss';
import '../../../components/loadingAtoms.js';
import '../../../rev/molecules/LoadingPage.scss';
import '../../../rev/molecules/NavigationMenu.scss';
import '@mui/icons-material/Search';
import 'react-aria';
import 'react-stately';
import 'smartystreets-javascript-sdk';
import 'smartystreets-javascript-sdk-utils';
import '../../../utils/addressCache.js';
import '../../../rev/molecules/OldAddressInput.scss';
import '../../../rev/atoms/Button.scss';
import '../../../rev/molecules/OrderFooter.scss';
import '../../../rev/molecules/Pagination.scss';
import '../../../rev/molecules/Popover.js';
import '../../../rev/molecules/Popup.scss';
import '../../../rev/molecules/SearchInput.scss';
import '../../../rev/molecules/Sheet.js';
import '../../../rev/molecules/Table/Table.scss';
import '../../../rev/molecules/Toast.js';
import '../../../rev/molecules/ToggleCard/ToggleCard.scss';
import '../../../rev/molecules/ToggleCard/ToggleCardDescriptionBlock.scss';
import '../../../rev/molecules/ToggleCard/ToggleCardGroup.scss';
import '../../../rev/molecules/ToggleCard/ToggleCardHeader.scss';
import '../../../rev/molecules/ToggleCard/ToggleCardRadioContent.scss';
import '@react-aria/utils';
import '../../../rev/molecules/TopBar.scss';
import '@mui/icons-material/Check';
import '../../../rev/organisms/ach/ConnectBankAccount.scss';
import '../../../rev/organisms/ach/ConnectedBankInfo.scss';
import '../../../rev/organisms/AddressInput.js';
import '../../../rev/sections/CalculatePaymentModal.scss';
import '../../../rev/sections/ConfirmAddressModal.scss';
import '../../../rev/sections/CoverageMenuSection/CoverageItemAssurance.scss';
import '../../../rev/sections/CoverageMenuSection/CoverageItemProductSummary.js';
import '../../../rev/sections/CoverageMenuSection/CoverageMenuSection.scss';
import '../../../rev/sections/CoverageMenuSection/fixtures/coverageMenuFixtureData.js';
import '../../../rev/sections/FormModal/schemas.js';
import '@hookform/resolvers/zod';
import '@internationalized/date';
import '../../../constants.js';
import '../../../rev/sections/FormModal/FormModal.scss';
import '../../../rev/sections/FormModal/types.js';
import 'moment';
import '../../../types/leads/Lead.js';
import '../../../rev/sections/LeadsSection/LeadCard.scss';
import { mfaSmsVerificationIdAtom, mfaSmsPhoneNumberAtom, clearMfaSmsStateAtom, setMfaSmsVerificationIdAtom } from '../../atoms/mfaSmsAtoms.js';
import { useSendSmsVerificationCode, useVerifyAndEnrollMfaSms } from '../../hooks/useEnrollMfaSms.js';
import { useAuthContext } from '../../providers/AuthContext.js';
import { AuthHeader } from '../common/AuthHeader.js';
import { PinInput } from '../common/PinInput.js';

const RESEND_COOLDOWN_SECONDS = 60;
const recaptchaContainerId = 'recaptcha-container-sms-code';
const DEFAULT_CODE_STEP_TITLE = 'Enter your verification code';
const DEFAULT_CODE_STEP_DETAILS = 'Check your phone and enter the 6-digit code we just sent via SMS';
/**
 * Verification code input step for SMS MFA enrollment
 * Handles code verification, resend, and phone number update
 */
function MfaSmsCodeInput({ onRequiresRecentLogin, checkRequiresRecentLogin, onEnrollmentComplete, codeStepTitle = DEFAULT_CODE_STEP_TITLE, codeStepDetails = DEFAULT_CODE_STEP_DETAILS, }) {
    const { mfaSmsService } = useAuthContext();
    const verificationId = useAtomValue(mfaSmsVerificationIdAtom);
    const phoneNumber = useAtomValue(mfaSmsPhoneNumberAtom);
    const clearMfaSmsState = useSetAtom(clearMfaSmsStateAtom);
    const setVerificationId = useSetAtom(setMfaSmsVerificationIdAtom);
    const recaptchaVerifierRef = useRef(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const [lastCodeSentAt, setLastCodeSentAt] = useState(null);
    const [resendCooldownSeconds, setResendCooldownSeconds] = useState(0);
    const { mutate: sendVerificationCode, isPending: isSendingCode, error: sendCodeError, reset: resetSendCodeMutation, } = useSendSmsVerificationCode();
    const { mutate: verifyAndEnroll, isPending: isVerifying, error: verifyError, reset: resetVerifyMutation, } = useVerifyAndEnrollMfaSms();
    const { control, handleSubmit, getValues, formState: { errors, isValid: _isValid, touchedFields, isSubmitted }, reset, } = useForm({
        mode: 'onChange',
        defaultValues: {
            code: '',
        },
    });
    // Handle resend cooldown timer
    useEffect(() => {
        if (lastCodeSentAt === null || resendCooldownSeconds <= 0) {
            return;
        }
        const interval = setInterval(() => {
            const elapsed = Math.floor((Date.now() - lastCodeSentAt) / 1000);
            const remaining = Math.max(0, RESEND_COOLDOWN_SECONDS - elapsed);
            if (remaining <= 0) {
                setResendCooldownSeconds(0);
                setLastCodeSentAt(null);
            }
            else {
                setResendCooldownSeconds(remaining);
            }
        }, 1000);
        return () => clearInterval(interval);
    }, [lastCodeSentAt, resendCooldownSeconds]);
    // Initialize reCAPTCHA verifier on mount
    useEffect(() => {
        if (!recaptchaVerifierRef.current) {
            try {
                recaptchaVerifierRef.current =
                    mfaSmsService.createRecaptchaVerifier(recaptchaContainerId);
            }
            catch (error) {
                console.error('Failed to initialize reCAPTCHA:', error);
                setErrorMessage('Failed to initialize verification. Please refresh the page.');
            }
        }
        // Cleanup reCAPTCHA on unmount
        return () => {
            if (recaptchaVerifierRef.current) {
                try {
                    recaptchaVerifierRef.current.clear();
                }
                catch (error) {
                    // Ignore cleanup errors
                    console.error('Error clearing reCAPTCHA:', error);
                }
                recaptchaVerifierRef.current = null;
            }
        };
    }, [mfaSmsService]);
    // Create retry callback for verify errors during reauth flow
    const createVerifyRetryCallback = useCallback(() => {
        return () => {
            // Reset mutation state
            resetVerifyMutation();
            setErrorMessage(null);
            // Get the current code and retry verification
            const code = getValues('code');
            if (code && verificationId) {
                const cleanedCode = code.replace(/\D/g, '');
                verifyAndEnroll({
                    verificationId,
                    verificationCode: cleanedCode,
                }, {
                    onSuccess: () => {
                        // MFA enrollment is complete in Firebase Auth
                        // Call the completion callback
                        onEnrollmentComplete();
                    },
                    onError: () => {
                        // Error message is handled by useEffect
                    },
                });
            }
        };
    }, [getValues, verificationId, resetVerifyMutation, verifyAndEnroll, onEnrollmentComplete]);
    // Create retry callback for resend errors during reauth flow
    const createResendRetryCallback = useCallback(() => {
        return () => {
            // Reset reCAPTCHA before retrying
            if (recaptchaVerifierRef.current) {
                try {
                    recaptchaVerifierRef.current.clear();
                    recaptchaVerifierRef.current =
                        mfaSmsService.createRecaptchaVerifier(recaptchaContainerId);
                }
                catch (clearError) {
                    console.error('Failed to reset reCAPTCHA:', clearError);
                }
            }
            // Reset mutation state
            resetSendCodeMutation();
            setErrorMessage(null);
            // Retry resend
            if (phoneNumber && recaptchaVerifierRef.current) {
                sendVerificationCode({
                    phoneNumber,
                    recaptchaVerifier: recaptchaVerifierRef.current,
                }, {
                    onSuccess: (id) => {
                        setVerificationId(id);
                        setLastCodeSentAt(Date.now());
                        setResendCooldownSeconds(RESEND_COOLDOWN_SECONDS);
                    },
                    onError: () => {
                        // Error message is handled by useEffect
                    },
                });
            }
        };
    }, [
        phoneNumber,
        resetSendCodeMutation,
        sendVerificationCode,
        setVerificationId,
        mfaSmsService,
    ]);
    // Update error message when mutations have errors
    useEffect(() => {
        // Check for requires-recent-login on verify/enroll errors
        if (verifyError && checkRequiresRecentLogin(verifyError)) {
            onRequiresRecentLogin(createVerifyRetryCallback());
            return;
        }
        // Check for requires-recent-login on resend errors
        if (sendCodeError && checkRequiresRecentLogin(sendCodeError)) {
            onRequiresRecentLogin(createResendRetryCallback());
            return;
        }
        if (sendCodeError) {
            setErrorMessage(sendCodeError.message);
            // If rate limited, extend the cooldown
            if (sendCodeError.code === 'auth/too-many-requests') {
                setResendCooldownSeconds(RESEND_COOLDOWN_SECONDS);
                setLastCodeSentAt(Date.now());
            }
            // Reset reCAPTCHA on error so user can try again
            if (recaptchaVerifierRef.current) {
                try {
                    recaptchaVerifierRef.current.clear();
                    recaptchaVerifierRef.current =
                        mfaSmsService.createRecaptchaVerifier(recaptchaContainerId);
                }
                catch (clearError) {
                    console.error('Failed to reset reCAPTCHA:', clearError);
                }
            }
        }
        else if (verifyError) {
            setErrorMessage(verifyError.message);
            if (verifyError.code === 'auth/session-expired' ||
                verifyError.code === 'auth/code-expired') {
                clearMfaSmsState();
            }
        }
    }, [
        sendCodeError,
        verifyError,
        clearMfaSmsState,
        checkRequiresRecentLogin,
        onRequiresRecentLogin,
        createVerifyRetryCallback,
        createResendRetryCallback,
        mfaSmsService,
    ]);
    // Reset form when verificationId changes (new code sent)
    useEffect(() => {
        reset();
        setErrorMessage(null);
    }, [verificationId, reset]);
    const codeSubmitHandler = handleSubmit((data) => {
        if (!verificationId) {
            clearMfaSmsState();
            return;
        }
        setErrorMessage(null);
        const cleanedCode = data.code.replace(/\D/g, '');
        verifyAndEnroll({
            verificationId,
            verificationCode: cleanedCode,
        }, {
            onSuccess: () => {
                // MFA enrollment is complete in Firebase Auth
                // Call the completion callback
                onEnrollmentComplete();
            },
            onError: () => {
                // Error message is handled by useEffect
            },
        });
    });
    const handleResend = () => {
        if (resendCooldownSeconds > 0) {
            // Cooldown is still active, don't allow resend
            return;
        }
        if (!phoneNumber || !recaptchaVerifierRef.current) {
            setErrorMessage('Please go back and enter your phone number again.');
            return;
        }
        // Reset reCAPTCHA for new attempt
        if (recaptchaVerifierRef.current) {
            try {
                recaptchaVerifierRef.current.clear();
                recaptchaVerifierRef.current =
                    mfaSmsService.createRecaptchaVerifier(recaptchaContainerId);
            }
            catch (error) {
                console.error('Failed to reset reCAPTCHA:', error);
                setErrorMessage('Failed to reset verification. Please try again.');
                return;
            }
        }
        setErrorMessage(null);
        sendVerificationCode({
            phoneNumber,
            recaptchaVerifier: recaptchaVerifierRef.current,
        }, {
            onSuccess: (id) => {
                setVerificationId(id);
                setLastCodeSentAt(Date.now());
                setResendCooldownSeconds(RESEND_COOLDOWN_SECONDS);
            },
            onError: () => {
                // Error message is handled by useEffect
                // Reset reCAPTCHA again on error
                if (recaptchaVerifierRef.current) {
                    try {
                        recaptchaVerifierRef.current.clear();
                        recaptchaVerifierRef.current =
                            mfaSmsService.createRecaptchaVerifier(recaptchaContainerId);
                    }
                    catch (clearError) {
                        console.error('Failed to reset reCAPTCHA:', clearError);
                    }
                }
            },
        });
    };
    const isCodeStepDisabled = isVerifying || isSendingCode;
    const isResendDisabled = isCodeStepDisabled || resendCooldownSeconds > 0;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Stack, { itemsSpacing: '24' },
            React__default.createElement(AuthHeader, { title: codeStepTitle, details: codeStepDetails }),
            errorMessage && (React__default.createElement(Callout, { title: 'Error', message: errorMessage, variant: 'error', appearance: 'filled' })),
            React__default.createElement("form", { onSubmit: codeSubmitHandler },
                React__default.createElement(Stack, { itemsSpacing: '24' },
                    React__default.createElement(Controller, { name: 'code', control: control, rules: {
                            required: 'Verification code is required',
                            validate: (value) => {
                                const cleaned = value.replace(/\D/g, '');
                                if (cleaned.length !== 6) {
                                    return 'Please enter a valid 6-digit code';
                                }
                                return true;
                            },
                        }, render: ({ field: { onChange, value } }) => (React__default.createElement(Stack, { itemsSpacing: '4' },
                            React__default.createElement(Stack, { itemsSpacing: '8' },
                                React__default.createElement(PinInput, { length: 6, value: value || '', onChange: onChange, isDisabled: isCodeStepDisabled, onComplete: () => codeSubmitHandler() }),
                                errors.code?.message &&
                                    (touchedFields.code || isSubmitted) && (React__default.createElement(Callout, { title: 'Error', message: errors.code?.message, variant: 'error', appearance: 'filled' }))))) }),
                    React__default.createElement(Button, { size: 'large', isFullWidth: true, isLoading: isVerifying, isDisabled: true, type: 'submit', onPress: () => codeSubmitHandler() }, "Continue"),
                    React__default.createElement(Button, { size: 'large', isFullWidth: true, variant: 'outline', onPress: handleResend, isLoading: isSendingCode, isDisabled: isResendDisabled }, resendCooldownSeconds > 0
                        ? `Resend code (${resendCooldownSeconds}s)`
                        : 'Resend code'),
                    React__default.createElement(Group, { itemsAlignX: 'start' },
                        React__default.createElement(Button, { variant: 'underlined', size: 'small', onPress: clearMfaSmsState, isDisabled: isCodeStepDisabled }, "Update phone number"))))),
        React__default.createElement("div", { id: recaptchaContainerId, style: {
                position: 'absolute',
                width: 0,
                height: 0,
                overflow: 'hidden',
                margin: 0,
                padding: 0,
            }, "aria-hidden": 'true' })));
}

export { MfaSmsCodeInput };
//# sourceMappingURL=MfaSmsCodeInput.js.map
